<template>
  <v-text-field
    v-model="searchTerm"
    class="mb-4"
    hide-details="auto"
    label="Search blogs"
    outlined
    dense
    @change="changeSearchTerm"
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchTermFilter',
  data: () => ({
    searchTerm: null,
  }),
  computed: mapState('route', ['query']),
  mounted() {
    this.searchTerm = this.query.searchTerm || null
  },
  methods: {
    changeSearchTerm(value) {
      const query = { ...this.query, page: 1 }

      if (value) query.searchTerm = value
      if (!value) delete query.searchTerm

      this.$router.push({ name: 'blog', query })
    },
  },
}
</script>
